import realistic from './realistic.png';
import analogFilm from './analog-film.png';
import artistic from './artistic.png';
import anime from './anime.png';
import digitalArt from './digital-art.png';
import fantasyArt from './fantasy-art.png';
import vaporwave from './vaporwave.png';
import isometric from './isometric.png';
import lowPoly from './low-poly.png';
import claymation from './claymation.png';
import origami from './origami.png';
import lineArt from './line-art.png';
import pixelArt from './pixel-art.png';

export const styleImages = {
  realistic,
  'analog-film': analogFilm,
  artistic,
  anime,
  'digital-art': digitalArt,
  'fantasy-art': fantasyArt,
  vaporwave,
  isometric,
  'low-poly': lowPoly,
  claymation,
  origami,
  'line-art': lineArt,
  'pixel-art': pixelArt,
} as const;
